module.exports = __webpack_public_path__ + "static/media/icon-navegue-espaco.a80aec51.svg";